import React from "react";

import Image from "../molecules/image";

import "../../scss/molecules/_client.scss";

class Client extends React.Component {
  render() {
    let clientBody = (
      <div className="client-media">
        <Image {...this.props.media} />
      </div>
    );

    return <div className="client">{clientBody}</div>;
  }
}

export default Client;
